module.exports = __webpack_public_path__ + "static/media/ice-cream.4c6867d9.svg";